import * as theme from "../theme";

const ThanksNoteForAnswers = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "GibsonLight",
        fontSize: "1.9vmin",
        backgroundColor: theme.COLORS.help_tip,
      }}
    >
      Thanks for the answers, We'll get back to you soon...
    </div>
  );
};

export default ThanksNoteForAnswers;
